import {
  collection,
  getDocs,
  orderBy,
  query,
  updateDoc,
  doc,
} from 'firebase/firestore';
import { db } from '../firebase';

export interface Candidature {
  id: string;
  userId?: string;
  postId?: string;
  status?: string;
  date?: Date;
  createdAt?: Date;
  updatedAt?: Date;
}

const COLLECTION = 'candidatures';

export async function listCandidatures(): Promise<Candidature[]> {
  const snap = await getDocs(
    query(collection(db, COLLECTION), orderBy('date', 'desc'))
  );
  return snap.docs.map((d) => {
    const data = d.data() as any;
    return {
      id: d.id,
      userId: data.userId,
      postId: data.postId,
      status: data.status,
      date: data.date?.toDate ? data.date.toDate() : undefined,
      createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : undefined,
      updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : undefined,
    };
  });
}

export async function updateCandidatureStatus(
  id: string,
  status: 'approved' | 'rejected' | 'pending'
): Promise<void> {
  const ref = doc(db, COLLECTION, id);
  await updateDoc(ref, { status });
}

